import React, { Suspense, lazy } from 'react';

const TiptapEditor = lazy(() => import('./TiptapEditor'));

function TiptapEditorFallback() {
  return (
    <div className="tiptap-editor-wrap">
      <label className="tiptap-editor-label">Check-in Rules</label>
      <div className="tiptap-editor-fallback">Loading editor…</div>
    </div>
  );
}

/** Lazy-loaded TipTap (avoids SSR issues in other stacks; keeps CRA bundle split). */
export default function TiptapEditorLazy(props) {
  return (
    <Suspense fallback={<TiptapEditorFallback />}>
      <TiptapEditor {...props} />
    </Suspense>
  );
}
